import gql from "@/util/graphql-query.mjs";

export const ChampionBuildsTagged = gql`
  query ChampionBuildsTagged(
    $championId: String!
    $matchupChampionId: String
    $queue: String!
    $role: String
    $tier: String
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_builds_tags"
      params: [
        { name: "individual_position", value: $role }
        { name: "queue_id", value: $queue }
        { name: "champion_id", value: $championId }
        { name: "build_tier", value: $tier }
        { name: "match_up_champion_id", value: $matchupChampionId }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        parameters
      }
      payload
    }
  }
`;

export const ChampionsStats = gql`
  query ChampionsStats(
    $queue: String!
    $tier: String
    $role: String
    $championId: String
    $region: String
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_postmatch_stats"
      params: [
        { name: "queue_id", value: $queue }
        { name: "tier", value: $tier }
        { name: "individual_position", value: $role }
        { name: "champion_id", value: $championId }
        { name: "region", value: $region }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ChampionMatchups = gql`
  query ChampionMatchups(
    $queue: String!
    $tier: String
    $region: String
    $role: String!
    $championId: String!
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_matchups_stats"
      params: [
        { name: "queue_id", value: $queue }
        { name: "tier", value: $tier }
        { name: "region", value: $region }
        { name: "individual_position", value: $role }
        { name: "champion_id", value: $championId }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ChampionSynergies = gql`
  query ChampionSynergies(
    $queue: String!
    $tier: String
    $region: String
    $champion_id: String!
    $individual_position: String!
    $ally_individual_position: String!
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_synergies_stats_unlimited"
      params: [
        { name: "queue_id", value: $queue }
        { name: "tier", value: $tier }
        { name: "region", value: $region }
        { name: "champion_id", value: $champion_id }
        { name: "individual_position", value: $individual_position }
        { name: "ally_individual_position", value: $ally_individual_position }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ChampionByMinuteStats = gql`
  query ChampionByMinuteStats(
    $queue: String!
    $tier: String
    $role: String
    $championId: String!
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_by_minute_stats"
      params: [
        { name: "champion_id", value: $championId }
        { name: "tier", value: $tier }
        { name: "queue_id", value: $queue }
        { name: "individual_position", value: $role }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ChampionByDurationStats = gql`
  query ChampionByDurationStats(
    $queue: String!
    $tier: String
    $role: String
    $championId: String!
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_by_game_duration_stats"
      params: [
        { name: "champion_id", value: $championId }
        { name: "tier", value: $tier }
        { name: "queue_id", value: $queue }
        { name: "individual_position", value: $role }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const RoleSynergies = gql`
  query RoleSynergies(
    $queue: String!
    $tier: String!
    $region: String
    $role1: String!
    $role2: String!
  ) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_champion_synergies_stats"
      params: [
        { name: "queue_id", value: $queue }
        { name: "tier", value: $tier }
        { name: "region", value: $region }
        { name: "individual_position", value: $role1 }
        { name: "ally_individual_position", value: $role2 }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ArenaAugmentsStats = gql`
  query ArenaAugmentsStats {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_arena_augments"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ArenaChampionsStats = gql`
  query ArenaChampionsStats {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_arena_champions"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

// Singular champion
export const ArenaChampionStats = gql`
  query ArenaChampionStats($championId: String!) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_arena_champion"
      params: [{ name: "champion_id", value: $championId }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const ArenaChampionsDuosStats = gql`
  query ArenaChampionsDuosStats {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_arena_duos"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const PBE_aramMayhem = gql`
  query PBE_aramMayhem {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_aram_mayhem_champions"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const PBE_aramMayhemChampionAugments = gql`
  query PBE_aramMayhemChampionAugments($champion_id: String!) {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_aram_mayhem_champion"
      params: [{ name: "champion_id", value: $champion_id }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const aramMayhemAugmentsStats = gql`
  query aramMayhemAugmentsStats {
    executeDatabricksQuery(
      game: LEAGUE
      queryName: "prod_aram_mayhem_augments"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;
